import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef, useState } from "react";
import MuiTextField from "@material-ui/core/TextField";
import MuiFormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
const useLabelStyles = makeStyles({
    root: {
        whitespace: "break-spaces",
        position: "relative",
        top: 0,
        marginBottom: -16
    },
    shrink: {
        transform: "translate(0, -20px) !important"
    }
}, { name: "DployTextFieldLabel" });
const useFormControlStyles = makeStyles({
    marginDense: {
        marginTop: 16
    },
    marginNormal: {}
}, { name: "DployFormControl" });
const useInputStyles = makeStyles({
    inputVariantOutline: {
        borderRadius: "0px"
    },
    selectVariantOutline: {
        borderRadius: 0,
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none"
    },
    noBorderVariantOutline: {
        borderStyle: "none"
    },
    multiline: {
        padding: 0
    },
    input: (props) => typeof props.textAlign === "string"
        ? {
            textAlign: props.textAlign
        }
        : {},
    square: {
        borderStyle: "none"
    },
    inputSquare: (props) => ({
        height: "100%",
        width: props.inputSquareWidth ?? "100%",
        resize: props.fullWidth ? "vertical" : "both",
        borderStyle: "solid",
        borderWidth: "0.933px",
        fontFamily: "Arial,Helvetica Neue,Helvetica,Roboto,sans-serif !important",
        fontSize: "11.5px",
        borderColor: "#a59bbf",
        minHeight: props.inputSquareMinHeight
    }),
    inputSquareOverridable: {},
    inputWrapperWithMaxLengthCaption: {
        flexDirection: "column",
        width: "100%"
    },
    maxLengthCaption: {
        display: "block",
        marginBottom: 8
    }
}, { name: "DployInput" });
const dployVariants = ["select", "input", "noBorder"];
const muiVariants = ["standard", "outlined", "filled"];
export const DployTextFieldInternal = (props, ref) => {
    const labelClasses = useLabelStyles(props);
    const inputClasses = useInputStyles(props);
    const { textAlign, maxLength, value, square, ...rest } = props;
    const [inputLength, setInputLength] = useState(value?.length ?? 0);
    const initialFieldValue = useRef(value);
    const fieldValue = props.locked ? initialFieldValue.current : value;
    if (rest.variant &&
        muiVariants.includes(rest.variant)) {
        const variant = rest.variant;
        return (_jsx(MuiTextField, { ref: ref, ...rest, value: fieldValue, variant: variant }));
    }
    const { variant = "input" } = props;
    const variantType = variant + "VariantOutline";
    const handleChange = (event) => {
        const rawValue = event.target.value;
        const value = maxLength ? rawValue.slice(0, maxLength) : rawValue;
        event.target.value = value;
        setInputLength(value.length);
        if (props.onChange) {
            props.onChange(event);
        }
    };
    const TextField = (_jsx(MuiTextField, { ...rest, ref: ref, value: fieldValue, autoComplete: props.autoComplete || "off", variant: "outlined", InputProps: {
            ...props.InputProps,
            notched: false,
            classes: {
                input: `${inputClasses.input} ${square
                    ? `${inputClasses.inputSquare} ${inputClasses.inputSquareOverridable}`
                    : ""}`,
                multiline: inputClasses.multiline,
                ...(props.InputProps && props.InputProps.classes),
                notchedOutline: `${square ? inputClasses.square : ""} ${inputClasses[variantType]}`
            }
        }, onChange: handleChange, minRows: rest.rows, maxRows: rest.rows, InputLabelProps: {
            shrink: true,
            classes: labelClasses,
            ...props.InputLabelProps
        } }));
    return maxLength && props.multiline ? (_jsxs("div", { className: inputClasses.inputWrapperWithMaxLengthCaption, children: [TextField, _jsx(Typography, { variant: "caption", className: inputClasses.maxLengthCaption, children: _jsx(FormattedMessage, { id: "form_fields.dployTextField.maxCharacterLength", defaultMessage: "{remaining} / {maxLength} characters", values: {
                        remaining: maxLength - inputLength,
                        maxLength: maxLength
                    } }) })] })) : (TextField);
};
DployTextFieldInternal.displayName = "DployTextField";
const DployTextField = forwardRef(DployTextFieldInternal);
const DployFormControlInternal = (props, ref) => {
    const formControlClasses = useFormControlStyles(props);
    const { textAlign, ...rest } = props;
    if (rest.variant && muiVariants.includes(rest.variant))
        return _jsx(MuiFormControl, { variant: "standard", ref: ref, ...rest });
    return (_jsx(MuiFormControl, { ...rest, ref: ref, variant: "outlined", classes: formControlClasses }));
};
DployFormControlInternal.displayName = "DployFormControl";
const DployFormControl = forwardRef(DployFormControlInternal);
export { DployTextField, DployFormControl };
//# sourceMappingURL=DployTextField.js.map